import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    container: 'space-y-3',
    title: 'text-sm fw-bold',
    upsellsWrapper: 'flex gap-3'
  }
} satisfies RecursivePartial<ProductConfig['upsells']>
